import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Divider, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { filterLogs } from '../../../../../../redux/actions/log'
import { IRootState } from '../../../../../../redux/types'
import { FavLogsTable } from './history/FavLogsTable'
import { ParentLogsTable } from './history/ParentLogsTable'
import { SystemLogsTable } from './history/SystemLogsTable'
import { VipLogsTable } from './history/VipLogsTable'

function UserHistory({ userId }: { userId: number | null }) {
  const dispatch = useDispatch()
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { globalLanguageId } = useSelector((state: IRootState) => state.global)

  useEffect(() => {
    if (authUser !== null && userId) {
      dispatch(filterLogs({ language_id: globalLanguageId, systemaction_id: 1, user_id: userId }))
    }
  }, [globalLanguageId, authUser])

  return (
    <Container className="noPadding">
      <Box mb={30}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel2a-content" id="panel2a-header">
            <Typography>Registros del Sistema</Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            <Box mt={2} width="100%" height="400px">
              <SystemLogsTable />
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
            <Typography>Registros VIP</Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            <Box mt={2} width="100%" height="400px">
              <VipLogsTable />
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel2a-content" id="panel2a-header">
            <Typography>Registros de Favoritos</Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            <Box mt={2} width="100%" height="400px">
              <FavLogsTable />
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel2a-content" id="panel2a-header">
            <Typography>Registros Superiores Asociados</Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            <Box mt={2} width="100%" height="400px">
              <ParentLogsTable />
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  )
}

export default UserHistory
